import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.join.js";
import http from '@/utils/http';
import { ElLoading } from 'element-plus';
import { message } from '@/utils/restMessage.js';
export default {
  data: function data() {
    return {
      sfjcxs: 1,
      //是否接触过销售
      sfjcsh: 1,
      //是否接触售后
      cpdd: [],
      //产品数据
      xzindex: -1,
      //点击分数选中
      position: '',
      //职位
      qt1: '',
      //第一大题其它文字
      qt2: '',
      //第三大题其它文字
      // 第一大题
      gjShow1: false,
      gjShow2: false,
      gjShow3: false,
      gjShow4: false,
      gjShow5: false,
      // 第二大题
      bmyShow1: false,
      bmyShow2: false,
      bmyShow3: false,
      bmyShow4: false,
      bmyShow5: false,
      bmyShow6: false,
      // 第三大题
      bhShow1: false,
      bhShow2: false,
      bhShow3: false,
      bhShow4: false,
      bhShow5: false,
      bwidth: true,
      //表单宽度
      phoneShow: true,
      //二维码状态
      tsStatus: false,
      //提示弹框状态
      imgStatus: false,
      //图片状态
      titleSize: 24,
      //标题大小
      mainpadding: 20,
      //整体边距
      radioShow: false,
      radio: false,
      //单选按钮
      myData1: ['非常满意', '满意', '一般', '不满意', '非常不满意'],
      fsData7: [{
        name: '产品质量',
        value: 1
      }, {
        name: '外观设计',
        value: 2
      }, {
        name: '软件功能',
        value: 3
      }, {
        name: '无',
        value: 4
      }],
      //产品满意度
      fsData8: [{
        name: '专业知识不足',
        value: 1
      }, {
        name: '沟通能力欠佳',
        value: 2
      }, {
        name: '服务态度不好',
        value: 3
      }, {
        name: '跟进不及时',
        value: 4
      }, {
        name: '过度推销',
        value: 5
      }, {
        name: '无',
        value: 6
      }],
      //售后体验
      fsData9: [{
        name: '响应速度慢',
        value: 1
      }, {
        name: '解决问题能力差',
        value: 2
      }, {
        name: '服务态度欠佳',
        value: 3
      }, {
        name: '缺乏主动跟进',
        value: 4
      }, {
        name: '无',
        value: 5
      }],
      //售后体验
      zwData: ['设备管理部', '工艺工程部', '采购部', '生产部', '品质品控部', '仓库管理部', 'IT', '管理'],
      //职位
      cplxData: [],
      //产品字典表
      bus: {
        salse: '',
        //销售人员
        type: 1,
        //售后调研
        openid: '',
        //openid
        lcbh: '',
        //流程编号
        orderno: '',
        //订单编号
        company: '',
        //公司
        contact: '',
        //联系人
        phone: '',
        //联系电话
        email: '',
        //邮箱
        position: '',
        //职位
        area: '',
        //区域
        product: '',
        //购买产品类型
        singlechoice1: 0,
        singlechoice2: 0,
        singlechoice3: 0,
        singlechoice4: 0,
        singlechoice5: 0,
        singlechoice6: 0,
        singlechoice7: 0,
        singlechoice8: 0,
        singlechoice9: 0,
        singlechoice10: 0,
        singlechoice11: 0,
        singlechoice12: 0,
        singlechoice13: null,
        suggestions1: '',
        //第一题填空题
        suggestions2: '',
        //第二题填空题
        suggestions3: '',
        //第三题填空题
        suggestions4: '',
        //第四题填空题
        multiplechoice1: [],
        //多选1
        multiplechoice2: [],
        //多选2
        multiplechoice3: [] //多选3

      },
      // 区域数据
      qyData: [{
        name: "北京",
        selected: false,
        value: 1
      }, {
        name: "天津",
        selected: false,
        value: 2
      }, {
        name: "上海",
        selected: false,
        value: 3
      }, {
        name: "重庆",
        selected: false,
        value: 4
      }, {
        name: "河北",
        selected: false,
        value: 5
      }, {
        name: "河南",
        selected: false,
        value: 6
      }, {
        name: "云南",
        selected: false,
        value: 7
      }, {
        name: "辽宁",
        selected: false,
        value: 8
      }, {
        name: "黑龙江",
        selected: false,
        value: 9
      }, {
        name: "湖南",
        selected: false,
        value: 10
      }, {
        name: "安徽",
        selected: false,
        value: 11
      }, {
        name: "山东",
        selected: false,
        value: 12
      }, {
        name: "新疆",
        selected: false,
        value: 13
      }, {
        name: "江苏",
        selected: false,
        value: 14
      }, {
        name: "浙江",
        selected: false,
        value: 15
      }, {
        name: "江西",
        selected: false,
        value: 16
      }, {
        name: "湖北",
        selected: false,
        value: 17
      }, {
        name: "广西",
        selected: false,
        value: 18
      }, {
        name: "甘肃",
        selected: false,
        value: 19
      }, {
        name: "山西",
        selected: false,
        value: 20
      }, {
        name: "内蒙古",
        selected: false,
        value: 21
      }, {
        name: "陕西",
        selected: false,
        value: 22
      }, {
        name: "吉林",
        selected: false,
        value: 23
      }, {
        name: "福建",
        selected: false,
        value: 24
      }, {
        name: "贵州",
        selected: false,
        value: 25
      }, {
        name: "广东",
        selected: false,
        value: 26
      }, {
        name: "青海",
        selected: false,
        value: 27
      }, {
        name: "西藏",
        selected: false,
        value: 28
      }, {
        name: "四川",
        selected: false,
        value: 29
      }, {
        name: "宁夏",
        selected: false,
        value: 30
      }, {
        name: "海南",
        selected: false,
        value: 31
      }, {
        name: "台湾",
        selected: false,
        value: 32
      }, {
        name: "香港",
        selected: false,
        value: 33
      }, {
        name: "澳门",
        selected: false,
        value: 34
      }],
      // 产品数据
      options: [{
        value: 'PLASMA 产品',
        label: 'PLASMA 产品',
        children: [{
          value: '常压等离子清洁设备',
          label: '常压等离子清洁设备'
        }, {
          value: '真空等离子清洁设备',
          label: '真空等离子清洁设备'
        }, {
          value: '数字电源',
          label: '数字电源'
        }, {
          value: '水滴角测试仪',
          label: '水滴角测试仪'
        }]
      }, {
        value: '离线测温类产品',
        label: '离线测温类产品',
        children: [{
          value: 'ROS穿梭型氧浓度测试仪',
          label: 'ROS穿梭型氧浓度测试仪'
        }, {
          value: 'iProfile系列炉温测试仪',
          label: 'iProfile系列炉温测试仪'
        }, {
          value: '鲸浪系列炉温测试仪',
          label: '鲸浪系列炉温测试仪'
        }, {
          value: '其它系列炉温测试',
          label: '其它系列炉温测试'
        }, {
          value: 'Mini',
          label: 'Mini'
        }]
      }, {
        value: '在线监控类产品',
        label: '在线监控类产品',
        children: [{
          value: 'PIS回流焊炉温实时监控系统',
          label: 'PIS回流焊炉温实时监控系统'
        }, {
          value: 'PIS回流焊炉温实时监控系统（真空版）',
          label: 'PIS回流焊炉温实时监控系统（真空版）'
        }, {
          value: 'WAPS波峰焊炉温实时监控系统',
          label: 'WAPS波峰焊炉温实时监控系统'
        }, {
          value: '多通道氧浓度分析仪',
          label: '多通道氧浓度分析仪'
        }]
      }, {
        value: '性能评估类产品',
        label: '性能评估类产品',
        children: [{
          value: 'Rcmk回流焊性能测试套件',
          label: 'Rcmk回流焊性能测试套件'
        }, {
          value: 'RPT轨道性能测试仪',
          label: 'RPT轨道性能测试仪'
        }, {
          value: 'WTT波峰焊温度测试套件',
          label: 'WTT波峰焊温度测试套件'
        }]
      }, {
        value: '自动加锡类产品',
        label: '自动加锡类产品',
        children: [{
          value: '自动添加锡膏设备',
          label: '自动添加锡膏设备'
        }, {
          value: '自动添加银浆设备',
          label: '自动添加银浆设备'
        }]
      }, {
        value: '其它产品',
        label: '其它产品',
        children: [{
          value: '吸嘴清洗机',
          label: '吸嘴清洗机'
        }]
      }]
    };
  },
  created: function created() {
    this.fo();
    this.cplxList();
    this.$route.query;

    if (this.$route.query.openid) {
      //openid
      this.bus.openid = this.$route.query.openid;
    }

    if (this.$route.query.lcbh) {
      this.bus.lcbh = this.$route.query.lcbh;
    }

    if (this.$route.query.email) {
      this.bus.email = this.$route.query.email;
    }

    var company = this.$route.query.company;

    if (company != null && company != 'undefined') {
      //公司名称
      this.bus.company = this.$route.query.company;
    }

    if (this.$route.query.lxr) {
      //联系人
      this.bus.contact = this.$route.query.lxr;
    }

    if (this.$route.query.dh) {
      //电话
      this.bus.phone = this.$route.query.dh;
    }

    if (this.$route.query.contact) {
      //联系人
      this.bus.contact = this.$route.query.contact;
    }

    if (this.$route.query.phone) {
      //电话
      this.bus.phone = this.$route.query.phone;
    }

    if (this.$route.query.salse) {
      //销售联系人
      this.bus.salse = this.$route.query.salse;
    } // let {dh,company} = this.$route.query
    // if(!company||!dh){//判断是否有公司名称和订单编号
    //     console.log(dh,company);
    //     this.tsStatus = true
    // }else{
    // if(window.screen.width<800){
    //     http.get(`/ksfweixinuser/get/by/company/phone?company=${company}&phone=${dh}`).then(res=>{
    //         console.log(res,'判断是否有关注公众号');
    //         let {code,data,description} = res.data
    //         if(200==code){
    //         }else{
    //             this.cuowu()
    //             // this.tsStatus = true
    //             // message({ type: "error", message: description });
    //         }
    //     })
    // }
    // }


    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      this.titleSize = 17;
      this.mainpadding = 0;
      this.bwidth = false;
      this.phoneShow = false;
    }
  },
  methods: {
    fo: function fo() {
      var _this = this;

      http.get('http://gitea.smtjhd.com/api/wx/getWXParam?url=http://gitea.smtjhd.com/survey/index.html#/login4').then(function (res) {
        var status = res.status,
            data = res.data;
        console.log(res, '获取微信参数');

        if (200 == status) {
          _this.appId = data.appId;
          _this.timestamp = data.timestamp;
          _this.nonceStr = data.nonceStr;
          _this.signature = data.signature;
          _this.lineLink = 'http://gitea.smtjhd.com/survey/index.html#/login4';

          _this.fo1();
        }
      });
    },
    fo1: function fo1() {
      var appId = this.appId,
          timestamp = this.timestamp,
          nonceStr = this.nonceStr,
          signature = this.signature,
          lineLink = this.lineLink;
      wx.config({
        debug: false,
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId,
        // 必填，公众号的唯一标识
        timestamp: timestamp,
        // 必填，生成签名的时间戳
        nonceStr: nonceStr,
        // 必填，生成签名的随机串
        signature: signature,
        // 必填，签名，见附录1
        jsApiList: ['updateAppMessageShareData', //分享给好友
        'updateTimelineShareData' //分享到朋友圈
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2

      });
      wx.ready(function () {
        console.log('准备进来了'); //自定义分享,小图标,标题,内容

        var imgUrl = "http://gitea.smtjhd.com/survey/customersurvey.png"; //(填写完整的图标地址)

        var shareTitle = "售后满意度调研";
        var descContent = "感谢您选择我们的服务！我们期待听到您的宝贵意见，您的反馈将帮助我们不断改进，为您提供更好的服务体验。"; // 配置分享给朋友

        wx.updateAppMessageShareData({
          title: shareTitle,
          desc: descContent,
          link: lineLink,
          imgUrl: imgUrl
        }); //分享到朋友圈

        wx.updateTimelineShareData({
          title: shareTitle,
          link: lineLink,
          imgUrl: imgUrl,
          success: function success(res) {
            wx.showToast({
              title: '分享成功'
            });
          },
          cancel: function cancel(res) {
            wx.showToast({
              title: '取消分享！'
            });
          },
          fail: function fail(res) {
            wx.showToast({
              title: '分享失败！！'
            });
          }
        });
      });
      wx.error(function (res) {// alert('返回的错误信息，'+res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    // 点击选中
    djxz: function djxz(index) {
      this.xzindex = index;
      this.bus.singlechoice13 = index;
    },
    // 没有基本数据跳转网页
    cuowu: function cuowu() {
      var _this$$route$query = this.$route.query,
          company = _this$$route$query.company,
          lxr = _this$$route$query.lxr,
          dh = _this$$route$query.dh,
          lcbh = _this$$route$query.lcbh,
          salse = _this$$route$query.salse;
      window.location.href = "http://gitea.smtjhd.com/wechat/index.html#/pages/shouquan/shouquan?company=".concat(company, "&lxr=").concat(lxr, "&dh=").concat(dh, "&lcbh=").concat(lcbh, "&salse=").concat(salse); // window.open('http://gitea.smtjhd.com/api/wx/login')
    },
    // 产品满意度1点击了
    hezuo: function hezuo(index) {
      var _this2 = this;

      switch (index) {
        case 0:
          this.gjShow1 = !this.gjShow1;

          if (this.gjShow1) {
            this.gjShow5 = false;
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this2.fsData7[index].name) {
                _this2.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        case 1:
          this.gjShow2 = !this.gjShow2;

          if (this.gjShow2) {
            this.gjShow5 = false;
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this2.fsData7[index].name) {
                _this2.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        case 2:
          this.gjShow3 = !this.gjShow3;

          if (this.gjShow3) {
            this.gjShow5 = false;
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this2.fsData7[index].name) {
                _this2.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        case 3:
          this.gjShow5 = !this.gjShow5;

          if (this.gjShow5) {
            this.gjShow1 = false;
            this.gjShow2 = false;
            this.gjShow3 = false;
            this.bus.multiplechoice1 = [];
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this2.fsData7[index].name) {
                _this2.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        default:
          break;
      }

      if (this.gjShow5 == false) {
        //没选中就删除无
        this.bus.multiplechoice1.map(function (v, i) {
          if (v == '无') {
            _this2.bus.multiplechoice1.splice(i, 1);
          }
        });
      }

      console.log(this.bus.multiplechoice1);
    },
    // 销售问题部分点击了
    hezuo1: function hezuo1(index) {
      var _this3 = this;

      switch (index) {
        case 0:
          this.bmyShow1 = !this.bmyShow1;

          if (this.bmyShow1) {
            this.bmyShow6 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this3.fsData8[index].name) {
                _this3.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 1:
          this.bmyShow2 = !this.bmyShow2;

          if (this.bmyShow2) {
            this.bmyShow6 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this3.fsData8[index].name) {
                _this3.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 2:
          this.bmyShow3 = !this.bmyShow3;

          if (this.bmyShow3) {
            this.bmyShow6 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this3.fsData8[index].name) {
                _this3.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 3:
          this.bmyShow4 = !this.bmyShow4;

          if (this.bmyShow4) {
            this.bmyShow6 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this3.fsData8[index].name) {
                _this3.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 4:
          this.bmyShow5 = !this.bmyShow5;

          if (this.bmyShow5) {
            this.bmyShow6 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this3.fsData8[index].name) {
                _this3.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 5:
          this.bmyShow6 = !this.bmyShow6;

          if (this.bmyShow6) {
            this.bmyShow1 = false;
            this.bmyShow2 = false;
            this.bmyShow3 = false;
            this.bmyShow4 = false;
            this.bmyShow5 = false;
            this.bus.multiplechoice2 = [];
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this3.fsData8[index].name) {
                _this3.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        default:
          break;
      }

      if (this.bmyShow6 == false) {
        this.bus.multiplechoice2.map(function (v, i) {
          if (v == '无') {
            _this3.bus.multiplechoice2.splice(i, 1);
          }
        });
      }

      console.log(this.bus.multiplechoice2);
    },
    // 售后满意度1点击了
    hezuo2: function hezuo2(index) {
      var _this4 = this;

      switch (index) {
        case 0:
          this.bhShow1 = !this.bhShow1;

          if (this.bhShow1) {
            this.bhShow5 = false;
            this.bus.multiplechoice3.push(this.fsData9[index].name);
          } else {
            this.bus.multiplechoice3.map(function (v, i) {
              if (v == _this4.fsData9[index].name) {
                _this4.bus.multiplechoice3.splice(i, 1);
              }
            });
          }

          break;

        case 1:
          this.bhShow2 = !this.bhShow2;

          if (this.bhShow2) {
            this.bhShow5 = false;
            this.bus.multiplechoice3.push(this.fsData9[index].name);
          } else {
            this.bus.multiplechoice3.map(function (v, i) {
              if (v == _this4.fsData9[index].name) {
                _this4.bus.multiplechoice3.splice(i, 1);
              }
            });
          }

          break;

        case 2:
          this.bhShow3 = !this.bhShow3;

          if (this.bhShow3) {
            this.bhShow5 = false;
            this.bus.multiplechoice3.push(this.fsData9[index].name);
          } else {
            this.bus.multiplechoice3.map(function (v, i) {
              if (v == _this4.fsData9[index].name) {
                _this4.bus.multiplechoice3.splice(i, 1);
              }
            });
          }

          break;

        case 3:
          this.bhShow4 = !this.bhShow4;

          if (this.bhShow4) {
            this.bhShow5 = false;
            this.bus.multiplechoice3.push(this.fsData9[index].name);
          } else {
            this.bus.multiplechoice3.map(function (v, i) {
              if (v == _this4.fsData9[index].name) {
                _this4.bus.multiplechoice3.splice(i, 1);
              }
            });
          }

          break;

        case 4:
          this.bhShow5 = !this.bhShow5;

          if (this.bhShow5) {
            this.bhShow1 = false;
            this.bhShow2 = false;
            this.bhShow3 = false;
            this.bhShow4 = false;
            this.bus.multiplechoice3 = [];
            this.bus.multiplechoice3.push(this.fsData9[index].name);
          } else {
            this.bus.multiplechoice3.map(function (v, i) {
              if (v == _this4.fsData9[index].name) {
                _this4.bus.multiplechoice3.splice(i, 1);
              }
            });
          }

          break;

        default:
          break;
      }

      if (this.bhShow5 == false) {
        //没选中就删除无
        this.bus.multiplechoice3.map(function (v, i) {
          if (v == '无') {
            _this4.bus.multiplechoice3.splice(i, 1);
          }
        });
      }

      console.log(this.bus.multiplechoice3);
    },
    // 产品类型字典表
    cplxList: function cplxList() {
      var _this5 = this;

      http.get("/ksfcustomersurvey/producttype").then(function (res) {
        var _res$data = res.data,
            code = _res$data.code,
            description = _res$data.description,
            data = _res$data.data;
        console.log(res, '产品类型字典表');

        if (200 == code) {
          _this5.cplxData = data;
        } else {
          message({
            type: "error",
            message: description
          });
        }
      });
    },
    // 点击显示图片
    tuShow: function tuShow() {
      this.imgStatus = true;
    },
    // 验证规则
    srule: function srule() {
      var _this$bus = this.bus,
          company = _this$bus.company,
          contact = _this$bus.contact,
          phone = _this$bus.phone,
          email = _this$bus.email,
          position = _this$bus.position,
          area = _this$bus.area,
          product = _this$bus.product,
          singlechoice1 = _this$bus.singlechoice1,
          singlechoice2 = _this$bus.singlechoice2,
          singlechoice3 = _this$bus.singlechoice3,
          singlechoice4 = _this$bus.singlechoice4,
          singlechoice5 = _this$bus.singlechoice5,
          singlechoice6 = _this$bus.singlechoice6,
          singlechoice7 = _this$bus.singlechoice7,
          singlechoice8 = _this$bus.singlechoice8,
          singlechoice9 = _this$bus.singlechoice9,
          singlechoice10 = _this$bus.singlechoice10,
          singlechoice11 = _this$bus.singlechoice11,
          singlechoice12 = _this$bus.singlechoice12,
          singlechoice13 = _this$bus.singlechoice13,
          suggestions1 = _this$bus.suggestions1,
          suggestions2 = _this$bus.suggestions2,
          suggestions3 = _this$bus.suggestions3,
          suggestions4 = _this$bus.suggestions4,
          multiplechoice1 = _this$bus.multiplechoice1,
          multiplechoice2 = _this$bus.multiplechoice2,
          multiplechoice3 = _this$bus.multiplechoice3; // 公司名称

      if (company == '') {
        message({
          type: "error",
          message: '公司名称不能为空'
        });
        return false;
      } // 联系人


      if (contact == '') {
        message({
          type: "error",
          message: '联系人不能为空'
        });
        return false;
      } // 电话


      if (phone == '') {
        message({
          type: "error",
          message: '联系电话不能为空'
        });
        return false;
      } // 邮箱


      if (email == '') {
        message({
          type: "error",
          message: '邮箱不能为空'
        });
        return false;
      } // let sun = /^1[3456789]\d{9}$/
      // if (!sun.test(phone)){
      //     console.log(sun.test(phone),'电话号码');
      //     message({ type: "error", message: '请输入正确的手机号' });
      // } else {
      //     return false
      // }
      // 职位


      if (position == '') {
        message({
          type: "error",
          message: '职位不能为空'
        });
        return false;
      } // 区域


      if (area == '') {
        message({
          type: "error",
          message: '区域不能为空'
        });
        return false;
      } // 产品类型


      if (this.cpdd.length == 0) {
        message({
          type: "error",
          message: '产品类型不能为空'
        });
        return false;
      } //产品满意度
      // 第1题


      if (singlechoice1 == 0) {
        message({
          type: "error",
          message: '产品满意度第1题不能为空'
        });
        this.bus.func = 0;
        return false;
      } // 第2题


      if (singlechoice2 == 0) {
        message({
          type: "error",
          message: '产品满意度第2题不能为空'
        });
        return false;
      } // 第3题


      if (singlechoice3 == 0) {
        message({
          type: "error",
          message: '产品满意度第3题不能为空'
        });
        return false;
      } // 第4题


      if (singlechoice4 == 0) {
        message({
          type: "error",
          message: '产品满意度第4题不能为空'
        });
        return false;
      } // 第5题


      if (multiplechoice1.length == 0 && this.qt1 == '') {
        message({
          type: "error",
          message: '产品满意度第5题不能为空'
        });
        return false;
      } // 第6题


      if (suggestions1 == '') {
        message({
          type: "error",
          message: '产品满意度第6题不能为空'
        });
        return false;
      } //销售服务满意度


      if (this.sfjcxs != 2) {
        // 第1题
        if (singlechoice5 == 0) {
          message({
            type: "error",
            message: '销售服务满意度第1题不能为空'
          });
          return false;
        } // 第2题


        if (singlechoice6 == 0) {
          message({
            type: "error",
            message: '销售服务满意度第2题不能为空'
          });
          return false;
        } // 第3题


        if (singlechoice7 == 0) {
          message({
            type: "error",
            message: '销售服务满意度第3题不能为空'
          });
          return false;
        } // 第4题


        if (multiplechoice2.length == 0) {
          message({
            type: "error",
            message: '销售服务满意度第4题不能为空'
          });
          return false;
        } //第5题


        if (suggestions2 == '') {
          message({
            type: "error",
            message: '销售服务满意度第5题不能为空'
          });
          return false;
        }
      } //售后服务满意度
      // 第1题


      if (this.sfjcsh != 2) {
        if (singlechoice8 == 0) {
          message({
            type: "error",
            message: '售后服务满意度第1题不能为空'
          });
          return false;
        } // 第2题


        if (singlechoice9 == 0) {
          message({
            type: "error",
            message: '售后服务满意度第2题不能为空'
          });
          return false;
        } // 第3题


        if (singlechoice10 == 0) {
          message({
            type: "error",
            message: '售后服务满意度第3题不能为空'
          });
          return false;
        } // 第4题


        if (singlechoice11 == 0) {
          message({
            type: "error",
            message: '售后服务满意度第4题不能为空'
          });
          return false;
        } // 第5题


        if (multiplechoice3.length == 0 && this.qt2 == '') {
          message({
            type: "error",
            message: '售后服务满意度第5题不能为空'
          });
          return false;
        } //第6题


        if (suggestions3 == '') {
          message({
            type: "error",
            message: '售后服务满意度第6题不能为空'
          });
          return false;
        }
      } //服务总体满意度
      // 第1题


      if (singlechoice12 == 0) {
        message({
          type: "error",
          message: '服务总体满意度第1题不能为空'
        });
        return false;
      } // 第2题


      if (singlechoice13 == null) {
        message({
          type: "error",
          message: '服务总体满意度第2题不能为空'
        });
        return false;
      } //第3题


      if (suggestions4 == '') {
        message({
          type: "error",
          message: '售后服务满意度第3题不能为空'
        });
        return false;
      }

      return true;
    },
    // 点击提交
    busAdd: function busAdd() {
      var _this6 = this;

      console.log(this.bus); // return

      if (!this.srule()) {
        return false;
      }

      if (this.qt1) {
        this.bus.multiplechoice1.push('其它-' + this.qt1);
      }

      if (this.qt2) {
        this.bus.multiplechoice3.push('其它-' + this.qt2);
      }

      if (this.position != '') {
        this.bus.position = '其它-' + this.position;
      }

      this.bus.product = this.cpdd.join('-');
      this.bus.multiplechoice1 = this.bus.multiplechoice1.join(',');
      this.bus.multiplechoice2 = this.bus.multiplechoice2.join(',');
      this.bus.multiplechoice3 = this.bus.multiplechoice3.join(',');
      console.log(this.bus, '传递的数据'); // return
      // 遮罩层

      var loading = ElLoading.service({
        lock: true,
        text: '提交中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      http.post("/ksfcustomersurvey3/save", this.bus).then(function (res) {
        var _res$data2 = res.data,
            code = _res$data2.code,
            description = _res$data2.description;
        console.log(res);

        if (200 == code) {
          loading.close();
          message({
            type: "success",
            message: '提交成功！'
          });
          _this6.imgStatus = true; //成功后清空数据

          for (var key in _this6.bus) {
            _this6.bus[key] = '';
          }

          _this6.bus.type = 1;
          _this6.qt1 = [];
          _this6.qt2 = [];
          _this6.cpdd = [];
          _this6.sfjcsh = 1;
          _this6.sfjcxs = 1;
          _this6.position = '';
          _this6.xzindex = -1;
          _this6.bus.singlechoice1 = 0, _this6.bus.singlechoice2 = 0, _this6.bus.singlechoice3 = 0, _this6.bus.singlechoice4 = 0, _this6.bus.singlechoice5 = 0, _this6.bus.singlechoice6 = 0, _this6.bus.singlechoice7 = 0, _this6.bus.singlechoice8 = 0, _this6.bus.singlechoice9 = 0, _this6.bus.singlechoice10 = 0, _this6.bus.singlechoice11 = 0, _this6.bus.singlechoice12 = 0, _this6.bus.singlechoice13 = null, _this6.bus.multiplechoice1 = [];
          _this6.bus.multiplechoice2 = [];
          _this6.bus.multiplechoice3 = [];
          _this6.gjShow1 = false;
          _this6.gjShow2 = false;
          _this6.gjShow3 = false;
          _this6.gjShow4 = false;
          _this6.gjShow5 = false;
          _this6.bmyShow1 = false;
          _this6.bmyShow2 = false;
          _this6.bmyShow3 = false;
          _this6.bmyShow4 = false;
          _this6.bmyShow5 = false;
          _this6.bmyShow6 = false;
          _this6.bhShow1 = false;
          _this6.bhShow2 = false;
          _this6.bhShow3 = false;
          _this6.bhShow4 = false;
          _this6.bhShow5 = false;
        } else {
          loading.close();
          message({
            type: "error",
            message: description
          });
        }
      }).catch(function (err) {
        loading.close();
        message({
          type: "error",
          message: '服务器错误，请联系管理员'
        });
      });
    }
  }
};